<div class="container">
    <app-section-header title="{{ title }}" [actionsTemplate]="actionsTemplate" [iconName]="'goBack'">
        <ng-template #actionsTemplate>
            <div class="actions">
                <button class="secondary-btn" (click)="cancel()">Cancel</button>
                <button class="primary-btn" (click)="checkSavingData()">{{ buttonLabel }}</button>
            </div>
        </ng-template>
    </app-section-header>

    <div class="cardsContainer">
        <app-contacts-single-overview [isReadOnly]="false" [contact]="contact" #overview></app-contacts-single-overview>
    </div>
</div>
